export const externalLinks = {
  // Social media and profiles
  twitch: "https://www.twitch.tv/dahveed_iy",
  twitter: "https://twitter.com/DavidIsrawi",
  github: "https://github.com/DavidIsrawi",
  instagram: "https://www.instagram.com/davidisrawi/",
  linkedin: "https://www.linkedin.com/in/davidisrawi/",
  strava: "https://www.strava.com/athletes/125204347",
  superSmashProfile: "https://www.supermajor.gg/ultimate/player/Dahveed?id=S1805146",
  resume: "https://drive.google.com/file/d/0BxHec4yAhjE_TExsYjlRbUcyLVU/view?usp=sharing&resourcekey=0-XjRa57thfhaPssVyodLjjQ",

  // Work and projects
  m365CopilotApp: "https://x.com/copilot/",
  harmonicVisualizer: "https://davidisrawi.github.io/harmonic-visualizer/",
  mlsAnalytics: "http://mlsanalytics.surge.sh/",
  summarizeMeSite: "http://summarizeme.surge.sh/",

  // GitHub repositories
  outfluenzaRepo: "https://github.com/cancanf3/outfluenza",
  allTheFeelsRepo: "https://github.com/DavidIsrawi/AllTheFeels",
  summarizeMeRepo: "https://github.com/DavidIsrawi/SummarizeMe",
  flavoredNewsRepo: "https://github.com/JoshuaKoh/LaCodingGranja_2016",
  salariesMlsRepo: "https://github.com/DavidIsrawi/SalariesMLS",
  salariesMlsVisualsRepo: "https://github.com/DavidIsrawi/SalariesMLS-Visuals",

  // Devpost submissions
  outfluenzaDevpost: "https://devpost.com/software/outfluenza-xmtew3",
  allTheFeelsDevpost: "https://devpost.com/software/allthefeels-9mdqs8",
  flavoredNewsDevpost: "https://devpost.com/software/lacodinggranja_2016",

  // Articles
  secureWebsiteArticle: "https://dev.to/davidisrawi/securing-your-website-in-4-minutes---what-why-and-how-of-https-3kcm",
  summarizerArticle: "https://dev.to/davidisrawi/build-a-quick-summarizer-with-python-and-nltk",
} as const
